
export const getString = asset => new Promise((resolve, reject) => {
  if (asset) {
    const reader = new FileReader();
    reader.readAsArrayBuffer(asset)
    reader.onload = () => resolve(Buffer.from(reader.result));
    reader.onerror = error => reject(error);
  }
});
